module.exports = __webpack_public_path__ + "static/media/1.38618738.jpg";